import { createPortal } from 'react-dom';

export default function CompareLookDetailModal({ open, item, onClose }) {
  if (!open || !item) return null;

  const title = item.detailTitle || item.label || 'Look details';
  const lines = Array.isArray(item.detailLines) ? item.detailLines.filter(Boolean) : [];

  return createPortal(
    <div
      className="looks-compare-detail-modal"
      role="presentation"
      onClick={() => onClose?.()}
    >
      <div
        className="looks-compare-detail-modal__card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="looks-compare-detail-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="looks-compare-detail-modal__close" onClick={() => onClose?.()}>
          Close
        </button>
        <h3 id="looks-compare-detail-title">{title}</h3>
        {item.image ? (
          <div className="looks-compare-detail-modal__preview">
            <img src={item.image} alt="" />
          </div>
        ) : null}
        {lines.length ? (
          <ul className="looks-compare-detail-modal__list">
            {lines.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        ) : (
          <p className="looks-compare-detail-modal__empty">No extra details for this capture.</p>
        )}
      </div>
    </div>,
    document.body,
  );
}
